import { delay } from 'lodash';

let iframeDoc;

export const initIframe = (setAppLoading) => {
    const iframe = document.getElementById('iframe-sgsante');
    iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
};

export const isRefused = () => $('#tzA7') && $('#tzA7').textContent === 'Accès Refusé !';

export const hideLayout = () => {
    colorTags(['body', 'html'], 'white');
    let tags = ['.pos5', '.pos6', '#dwwM64'];
    // We hide the header, footer, breadcrumb (and menu if classic page)
    if (isPrivateSpace()) {
        // Private space
        tags = [...tags, '.pos153', '.pos157', '#dwwM4'];
    } else if (getCurrentPage() === 'Déclarer un nouvel arrêt de travail') {
        // 'Déclarer un arrêt de travail' sub page
        tags = ['#dwwM64', '#dwwM3', '.pos7', '.pos11 ~ div', '.pos13', '.pos3'];
    } else {
        // Classic page
        tags = [...tags, '.pos4', '.pos8 ~ div', '.pos10', '#dwwM3'];
        $('.pos10').parentElement.parentElement.style.display = 'none';
        $$('table, tr').forEach((o) => (o.style.height = 'initial'));
    }

    hideTags(tags);
};

const menuClickSelector = (menuId, menuTxt) => {
    const iframe = document.getElementById('iframe-sgsante');
    const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
    const spans = [...innerDoc.querySelectorAll('span.btnvalignmiddle')].filter((a) => a.textContent.includes(menuTxt));
    if (spans?.[0]?.parentNode?.parentNode !== undefined) spans[0].parentNode.parentNode.click();
};

export const menuClick = (menuId, isHidden, menuTxt) => {
    return new Promise((resolve, reject) => {
        // We need to give isHidden because it's too fast to see the change
        // and isHidden will hide the iframe (isHidden is managed in the layout)
        // A better way would have been to wait for the last page to load thanks
        // to a specific element (and that for the 3 conditions)

        const declaration = "Déclaration d'arrêt de travail";
        const radiation = "Radiation d'un salarié";

        menuTxt = radiation;
        if (window.location.pathname === '/arrets/create') menuTxt = declaration;

        if (isPrivateSpace() && !isHidden) {
            // START refactoring
            if (!menuTxt) {
                let timelapse = 0;
                const clickInterval = setInterval(() => {
                    const iframe = document.getElementById('iframe-sgsante');
                    const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
                    const spans = [...innerDoc.querySelectorAll('span.btnvalignmiddle')].filter((a) => a.textContent.includes(menuTxt));
                    timelapse += 20;
                    if (spans?.[0]?.parentNode?.parentNode !== undefined || timelapse > 9000) {
                        menuClickSelector(menuId, menuTxt);
                        clearInterval(clickInterval);
                        resolve();
                    }
                }, 200);
            } else {
                // If we are on the private space
                menuClickSelector(menuId, menuTxt);
                resolve();
            }
            // END refatoring
        } else if (!menuId) {
            // If we want to go on the private space
            goToPrivateSpace();
            // The best way would have been to do what has been described above
            setTimeout(() => {
                resolve();
            }, 20);
        } else {
            // We access to the menu
            // For that we try to click on the menu every 200ms for 5 seconds
            // (to manage the loading time via ajax from the webdev menu)
            goToPrivateSpace();
            let timelapse = 0;
            const clickInterval = setInterval(() => {
                const elem = $(`#${menuId}`);
                timelapse += 20;
                if (elem || timelapse > 9000) {
                    console.log(elem);
                    menuClickSelector(menuId, menuTxt);
                    clearInterval(clickInterval);
                    resolve();
                }
            }, 200);
        }
    });
};

export const goToPrivateSpace = () => {
    $('#tzM64')?.firstChild.click();
};

export const clickText = (text) => {
    const elem = Array.from($$('span')).find((o) => o.textContent.trim() === text.trim());
    if (elem) {
        elem.click();
    }
};

export const setFrameUrl = () => {
    if (document.getElementById('iframe-sgsante')) {
        var iFrameUrl = document.getElementById('iframe-sgsante').contentWindow.location.href;
        if (iFrameUrl !== 'about:blank') {
            localStorage.setItem('iframeUrl', iFrameUrl);
        }
    }
};

export const isPrivateSpace = () => $('#tzM143') === null;

const getCurrentPage = () => $('#tzM64').lastChild && $('#tzM64').lastChild.textContent;

const $ = (selector) => (iframeDoc ? iframeDoc.querySelector(selector) : null);

const $$ = (selector) => (iframeDoc ? iframeDoc.querySelectorAll(selector) : null);

const colorTags = (selectors, color) => selectors.forEach((o) => ($(o).style.background = color));

const removeLoader = () => {
    const loader = document.getElementById('loadingPage');
    const loaiFrameLoaderder = document.getElementById('iFrameLoader');
    const iframe = document.getElementById('iframe-sgsante');
    loader.style.display = 'none';
    loaiFrameLoaderder.style.display = 'none';
    iframe.style.visibility = 'visible';
};

const hideTags = (selectors) => {
    selectors.forEach((o) => {
        const elem = $(o);
        if (elem) {
            elem.style.display = 'none';
        }
    });

    delay(removeLoader, 10);
};
